module.exports = __webpack_public_path__ + "static/media/ftrustee.d573d0ee.png";